import { _ } from "../functions/translator";

class Enum {
    constructor(name, value) {
        this.name = name
        this.value = value
    }
}

export class CardsGroupStatus extends Enum {
    static STAND_BY = 'stand by';
    static OPEN = 'open';
    static IN_PROGRESS = 'in progress';
    static WITH_NO_CONFORMITIES = 'with no conformities';
    static CLOSED = 'closed';
    static UNFULFILLED = 'unfulfilled'
}

export class AnswersStatus extends Enum {
    static ACCEPTED = 'accepted'
    static OBSERVATION = 'observation'
    static NOT_APPLICABLE = 'not applicable'
    static PENDING = 'pending'
    static MEASUREMENT_ONLY = 'measurement only'
}

export const cardsGroupStates = {
    [CardsGroupStatus.STAND_BY]: _('No Liberado'),
    [CardsGroupStatus.OPEN]: _('A Revisar'), 
    [CardsGroupStatus.IN_PROGRESS]: _('En Proceso'), 
    [CardsGroupStatus.WITH_NO_CONFORMITIES]: _('Con Observaciones'),
    [CardsGroupStatus.CLOSED]: _('Cerrado'),
    [CardsGroupStatus.UNFULFILLED]: _('Incumplimiento'),
}

export const cardsGroupInRevisionStatus = [
    CardsGroupStatus.OPEN,
    CardsGroupStatus.IN_PROGRESS,
    CardsGroupStatus.WITH_NO_CONFORMITIES
]

export const colors = {
    [CardsGroupStatus.STAND_BY]: "rgb(255, 171, 0)",
    [CardsGroupStatus.OPEN]: "rgb(0, 144, 231)",
    [CardsGroupStatus.IN_PROGRESS]: "rgb(143, 95, 232)",
    [CardsGroupStatus.WITH_NO_CONFORMITIES]: "rgb(252, 66, 74)",
    [CardsGroupStatus.CLOSED]: "rgb(0, 210, 91)",
    [CardsGroupStatus.UNFULFILLED]: "rgb(170, 170, 170)",
    onstageobra: "rgb(255, 83, 0)"
}

export const colorClasses = {
    [CardsGroupStatus.STAND_BY]: "warning",
    [CardsGroupStatus.OPEN]: "primary",
    [CardsGroupStatus.IN_PROGRESS]: "info",
    [CardsGroupStatus.WITH_NO_CONFORMITIES]: "danger",
    [CardsGroupStatus.CLOSED]: "success",
    [CardsGroupStatus.UNFULFILLED]: "secondary",
}

export const progressColors = {
    'not_initialized': 'rgb(255, 0, 0)',
    '0-75': 'rgb(255, 128, 0)',
    '75-90': 'rgb(255, 255, 0)',
    '90-100': 'rgb(128, 255, 0)',
    '100-not_released': 'rgb(0, 255, 0)',
    '100-released': 'rgb(0, 144, 231)'
}

export const templateColors = {
    'main-color': '#191c20',
    'main-color-light': '#2e2f32',
}

export const delayedColors = {
    notDelayed: 'rgb(228, 234, 236)',
    oneDayDelayed: 'rgb(255, 255, 159)',
    threeDaysDelayed: 'rgb(255, 223, 0)',
    fiveDaysDelayed: 'rgb(255, 170, 29)',
    delayed: 'rgb(252, 66, 74)',
}

export const paidPhysicalProgressColors = {
    notComplete: 'red',
    physicalComplete: 'yellow',
    paidComplete: 'green',
    fullyComplete: 'blue'
};

export const cardsGroupsWithHistoricalObservationsColors = {
    withHistoricalObservations: 'red',
    withOutHistoricalObservations: 'white',
};

export const datesColors = {
    "sunday": '#0015ff',
    "monday": '#ff0000',
    "tuesday": '#FF5F1F',
    "wednesday": '#fbff22',
    "thursday": '#04ff00',
    "friday": '#b7ffb6',
    "saturday": '#bf00ff',
};

export const weeksColors = {
    "Semana 1": '#0015ff',
    "Semana 2": '#ff0000',
    "Semana 3": '#FF5F1F',
    "Semana 4": '#fbff22',
    "Semana 5": '#04ff00',
    "Semana 6": '#b7ffb6',
    "Semana 7": '#bf00ff',
    "Semana 8": '#5c330a',
};

export const monthsColors = {
    "Mes 1": '#0015ff',
    "Mes 2": '#ff0000',
    "Mes 3": '#FF5F1F',
    "Mes 4": '#fbff22',
    "Mes 5": '#04ff00',
    "Mes 6": '#b7ffb6',
    "Mes 7": '#bf00ff',
    "Mes 8 +": '#5c330a',
};

export const statusLegendInfo = {
    [CardsGroupStatus.STAND_BY]: {
        color: colors[CardsGroupStatus.STAND_BY],
        description: cardsGroupStates[CardsGroupStatus.STAND_BY]
    },
    [CardsGroupStatus.OPEN]: {
        color: colors[CardsGroupStatus.OPEN],
        description: cardsGroupStates[CardsGroupStatus.OPEN]
    }, 
    [CardsGroupStatus.IN_PROGRESS]: {
        color: colors[CardsGroupStatus.IN_PROGRESS],
        description:cardsGroupStates[CardsGroupStatus.IN_PROGRESS]
    }, 
    [CardsGroupStatus.WITH_NO_CONFORMITIES]: {
        color: colors[CardsGroupStatus.WITH_NO_CONFORMITIES],
        description: cardsGroupStates[CardsGroupStatus.WITH_NO_CONFORMITIES]
    },
    [CardsGroupStatus.CLOSED]: {
        color: colors[CardsGroupStatus.CLOSED],
        description: cardsGroupStates[CardsGroupStatus.CLOSED]
    },
    [CardsGroupStatus.UNFULFILLED]: {
        color: colors[CardsGroupStatus.UNFULFILLED],
        description: cardsGroupStates[CardsGroupStatus.UNFULFILLED]
    }
}

export const progressLegendInfo = {
    'not_initialized': { 
        color: progressColors['not_initialized'],
        description: _('No') + ' ' + _('Iniciado') 
    },
    '0-75': { 
        color: progressColors['0-75'],
        description: _('Menos del') + ' 75%'
    },
    '75-90': { 
        color: progressColors['75-90'],
        description: _('Entre el') + ' 75% - 90%' 
    },
    '90-100':{ 
        color: progressColors['90-100'],
        description:  _('Sobre') + ' 90% - '+ _('Bajo') +' 100%'
    },
    '100-not_released': { 
        color: progressColors['100-not_released'],
        description: '100% '+ _('Por Entregar') 
    },
    '100-released': { 
        color: progressColors['100-released'],
        description: '100% '+ _('Entregado')
    }
}

export const delayedLegendInfo = {
    notDelayed: {
        color: delayedColors.notDelayed,
        description: _('No Atrasado'),
    },
    oneDayDelayed: {
        color: delayedColors.oneDayDelayed,
        description: _('Atrasado')+ ' (1 '+ _('Día')+')',
    },
    threeDaysDelayed: {
        color: delayedColors.threeDaysDelayed,
        description: _('Atrasado')+' (1 ' + _('a')+' 3 '+ _('Días')+')',
    },
    fiveDaysDelayed: {
        color: delayedColors.fiveDaysDelayed,
        description: _('Atrasado')+' (3 '+ _('a')+' 5 '+ _('Días')+')',
    },
    delayed: {
        color: delayedColors.delayed,
        description: _('Atrasado')+' (+5 '+ _('Días')+')',
    },
}

export const PaidLegendInfo = {
    'not_paid-not_released': {
        color: paidPhysicalProgressColors.notComplete,
        description: _('No') + ' ' + _('Pagado') + ' ' + _('y') + ' ' + _('No') + ' ' + _('Entregado'),
    },
    'not_paid-realesed': {
        color: paidPhysicalProgressColors.physicalComplete,
        description: _('No') + ' ' + _('Pagado') + ' ' + _('y') + ' ' + _('Entregado'),
    },
    'paid-not_realesed': {
        color: paidPhysicalProgressColors.paidComplete,
        description: _('Pagado') + ' ' + _('y') + ' ' + _('No') + ' ' + _('Entregado'),
    },
    'paid-realesed': {
        color: paidPhysicalProgressColors.fullyComplete,
        description: _('Pagado') + ' ' + _('y') + ' ' + _('Entregado'),
    },
}

export const HistoricalObservationsLegendInfo = {
    'with_historical_observations': {
        color: cardsGroupsWithHistoricalObservationsColors.withHistoricalObservations,
        description: _('Con Observaciones Históricas'),
    },
    'without_historical_observations': {
        color: cardsGroupsWithHistoricalObservationsColors.withOutHistoricalObservations,
        description: _('Sin Observaciones Históricas'),
    },
}


export const DatesLegendInfo = {
    'sunday': {
        color: datesColors.sunday,
        description: _('Domingo'),
    },
    'monday': {
        color: datesColors.monday,
        description: _('Lunes'),
    },
    'tuesday': {
        color: datesColors.tuesday,
        description: _('Martes'),
    },
    'wednesday': {
        color: datesColors.wednesday,
        description: _('Miércoles'),
    },
    'thursday': {
        color: datesColors.thursday,
        description: _('Jueves'),
    },
    'friday': {
        color: datesColors.friday,
        description: _('Viernes'),
    },
    'saturday': {
        color: datesColors.saturday,
        description: _('Sábado'),
    },
}

export const layerFilters = {
    'cardPointLayer': ['==', '$type', 'Point'],
    'cardLineStringLayer': ['==', '$type', 'LineString'],
    'cardPolygonLayer': ['==', '$type', 'Polygon'],
    'cardOutlinePolygonLayer': ['==', '$type', 'Polygon'],
}

export const allLayers = [
    'cardPointLayer',
    'cardLineStringLayer',
    'cardPolygonLayer',
    'cardOutlinePolygonLayer'
]

export const allSelectableLayers = [
    'cardPointLayer',
    'cardLineStringLayer',
    'cardPolygonLayer'
]

export const allLayersColorProperty = {
    'cardPointLayer': 'icon-color',
    'cardLineStringLayer': 'line-color',
    'cardPolygonLayer': 'fill-extrusion-color',
    'cardOutlinePolygonLayer': 'line-color'
}

export const allLayersOpacityProperty = {
    'cardPointLayer': 'icon-opacity',
    'cardLineStringLayer': 'line-opacity',
    'cardPolygonLayer': 'fill-extrusion-opacity',
    'cardOutlinePolygonLayer': 'line-opacity',
}

export class ColorAttributes extends Enum {
    static CARD_CATEGORY = 'color';
    static STATUS = 'status_color';
    static PROGRESS = 'physical_progress';
    static DELAYED = 'delayed_percentage';
    static PAID_PHYSICAL_PROGRESS = 'paid_physical_progress';
    static HISTORICAL_OBSERVATIONS = 'historical_observations';
    static DATES = 'dates';
}

export const basePaintProperty = [
    'case',
    ['any', 
        ['boolean', ['feature-state', 'highlight'], false],
        ['boolean', ['feature-state', 'hover'], false]
    ],
    colors['onstageobra'],
];

export const paintProperties = {
    [ColorAttributes.CARD_CATEGORY]: ['get', ColorAttributes.CARD_CATEGORY],
    [ColorAttributes.STATUS]: ['to-color', ['feature-state', ColorAttributes.STATUS], 'white'],
    [ColorAttributes.PROGRESS]: [
        'interpolate', ['linear'], 
        ['to-number', ['feature-state', ColorAttributes.PROGRESS], 0],
        0,
        progressColors['not_initialized'],
        90,
        progressColors['75-90'],
        100,
        progressColors['100-not_released'],
        150,
        progressColors['100-released']
    ],
    [ColorAttributes.DELAYED]: [
        'interpolate', ['linear'], 
        ['to-number', ['feature-state', ColorAttributes.DELAYED], 0],
        0,
        delayedColors.notDelayed,
        1,
        delayedColors.oneDayDelayed,
        3,
        delayedColors.threeDaysDelayed,
        5,
        delayedColors.fiveDaysDelayed,
        7,
        delayedColors.delayed,
    ],
    [ColorAttributes.PAID_PHYSICAL_PROGRESS]: 
    ['to-color', ['feature-state', ColorAttributes.PAID_PHYSICAL_PROGRESS], 'white'],
    [ColorAttributes.HISTORICAL_OBSERVATIONS]: 
    ['to-color', ['feature-state', ColorAttributes.HISTORICAL_OBSERVATIONS], 'white'],
    [ColorAttributes.DATES]: 
    ['to-color', ['feature-state', ColorAttributes.DATES], 'white'],
};

export class ToggleActions extends Enum {
    static MENU = 'TOOGLE_MENU';
    static GRAPH = 'TOGGLE_GRAPH';
    static NUMBERS = 'TOGGLE_NUMBERS';
    static TIMELINE = 'TOGGLE_TIMELINE';
    static ITEMS = 'TOGGLE_ITEMS';
    static EXTENDED_GRAPH = 'TOGGLE_EXTENDED_GRAPH';
    static PRICE_GRAPH = 'TOGGLE_PRICE_GRAPH';
    static SIGNATURE = 'TOGGLE_SIGNATURE';
    static FULL_BUILDING = 'TOGGLE_FULL_BUILDING';
    static LOADING_LEVEL = 'TOGGLE_LOADING_LEVEL';
    static LOADING_ITEMS = 'TOGGLE_LOADING_ITEMS';
    static CARDS_LOADING = 'TOGGLE_CARDS_LOADING';
    static PLANNED_TIMELINE = 'TOGGLE_PLANNED_TIMELINE';
    static AXLES = 'TOGGLE_AXLES';
    static SHOW_APPARTMENT_FILTER = 'TOGGLE_SHOW_APPARTMENT_FILTER';
    static METRICS = 'TOGGLE_METRICS';
    static RELEASE_DATE = 'TOGGLE_RELEASE_DATE';
    static SELECT_PROTOCOL = 'TOGGLE_SELECT_PROTOCOL';
    static REFRESH = 'TOGGLE_REFRESH';
    static LEGEND = 'TOGGLE_LEGEND';
    static LOADED_MAP = 'TOGGLE_LOADED_MAP';
    static ROAD_LABEL = 'TOGGLE_ROAD_LABEL';
    static DEMO = ' TOGGLE_DEMO';
    static EDIT_MODE = ' TOGGLE_EDIT_MODE';
    static CHANGE_CATEGORY_COMPONENT = ' TOGGLE_CHANGE_CATEGORY_COMPONENT';
    static CHANGE_LEVEL_COMPONENT = ' TOGGLE_CHANGE_LEVEL_COMPONENT';
    static SIGNATURES_FILTER = ' TOGGLE_SIGNATURES_FILTER';
    static CREATE_BREAK_MODE = ' TOGGLE_CREATE_BREAK_MODE';
    static CREATE_BREAK_MODAL = ' TOGGLE_CREATE_BREAK_MODAL';
    static ADD_NEW_REGISTER = ' TOGGLE_ADD_NEW_REGISTER';
    static TUNNEL_SUBDIVISION = ' TOGGLE_TUNNEL_SUBDIVISION';
    static GANTT_CHART_DATES = ' TOGGLE_GANTT_CHART_DATES';
}

export class FilterActions extends Enum {
    static STAGES = 'FILTER_STAGES';
    static LEVELS = 'FILTER_LEVELS';
    static CARD_CATEGORIES = 'FILTER_CARD_CATEGORIES';
    static PROTOCOLGROUPS = 'FILTER_PROTOCOLGROUPS';
    static PROTOCOLS = 'FILTER_PROTOCOLS';
    static STATUS = 'FILTER_STATUS';
    static APPARTMENTS = 'FILTER_APPARTMENTS';
    static ZONES = 'FILTER_ZONES';
    static CUSTOMCARD = 'FILTER_CUSTOMCARD';
    static CARDS_GROUP_IDS = 'FILTER_CARDS_GROUP_IDS';
    static VOLUME = 'FILTER_VOLUME';
    static AREA = 'FILTER_AREA';
    static SURFACE = 'FILTER_SURFACE';
    static HEIGHT = 'FILTER_HEIGHT';
    static BIM_ELEMENTS = 'FILTER_BIM_ELEMENTS';
    static IS_DELAYED = 'FILTER_IS_DELAYED';
    static DEMO_URL = 'FILTER_DEMO_URL';
    static HISTORICAL_OBSERVATIONS = 'HISTORICAL_OBSERVATIONS';
    static TIME_SELECT = 'FILTER_TIME_SELECT';
    static CUSTOMCARD_TYPES = 'FILTER_CUSTOMCARD_TYPES';
    static DATE_RANGE = 'FILTER_DATE_RANGE';
    static USERS_IN_CHARGE = 'FILTER_USERS_IN_CHARGE';
}

export const defaultAreaWidth = 0.25;

export const earthRadius = 6378000;

export const defaultOpacity = 0.8;